import { useId } from 'react';
import type { Rank, Side } from '@cc/shared';

export function CoinSVG({ rank, side, size = 56, face, className = '', title }: { rank: Rank; side: Side; size?: number; face?: 'edge'; className?: string; title?: string }) {
  const gradientId = useId().replace(/:/g, '');
  const numeral = ['', 'Ⅰ', 'Ⅱ', 'Ⅲ', 'Ⅳ'][rank];
  if (face === 'edge') return <svg className={`coin-svg ${className}`} width={size} height={size} viewBox="0 0 100 100" aria-label={title ?? `Rank ${rank} coin, edge-on`} role="img"><ellipse cx="50" cy="50" rx="47" ry="9" fill={side === 'gold' ? '#e0a500' : '#9fb0c0'} stroke={side === 'gold' ? '#a97a1f' : '#64798c'} strokeWidth="5" /></svg>;
  const gold = side === 'gold';
  return (
    <svg className={`coin-svg coin-svg--${side} ${className}`} width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title ?? `${side} rank ${rank} coin`}>
      <defs><radialGradient id={gradientId} cx="35%" cy="25%"><stop stopColor={gold ? '#ffe066' : '#eef2f6'} /><stop offset="1" stopColor={gold ? '#f5b800' : '#b4c3d1'} /></radialGradient></defs>
      <circle cx="50" cy="50" r="47" fill={`url(#${gradientId})`} stroke={gold ? '#a97a1f' : '#64798c'} strokeWidth="5" />
      {gold ? Array.from({ length: 8 }, (_, index) => {
        const angle = (Math.PI * 2 * index) / 8;
        return <circle key={index} cx={50 + Math.cos(angle) * 36} cy={50 + Math.sin(angle) * 36} r="2.5" fill="#a97a1f" />;
      }) : <circle cx="50" cy="50" r="35" fill="none" stroke="#64798c" strokeWidth="2.5" strokeDasharray="6 4" />}
      <text x="50" y="62" textAnchor="middle" fontFamily="Nunito, sans-serif" fontWeight="900" fontSize="36" fill={gold ? '#8f691d' : '#53697c'}>{numeral}</text>
    </svg>
  );
}
